import { createContext, useContext, useState, ReactNode } from 'react';

interface ImpersonationContextType {
  impersonatedArtistId: string | null;
  impersonatedName: string | null;
  startImpersonation: (artistId: string, artistName: string) => void;
  stopImpersonation: () => void;
  isImpersonating: boolean;
}

const ImpersonationContext = createContext<ImpersonationContextType>({
  impersonatedArtistId: null,
  impersonatedName: null,
  startImpersonation: () => {},
  stopImpersonation: () => {},
  isImpersonating: false,
});

export function ImpersonationProvider({ children }: { children: ReactNode }) {
  const [impersonatedArtistId, setImpersonatedArtistId] = useState<string | null>(null);
  const [impersonatedName, setImpersonatedName] = useState<string | null>(null);

  const startImpersonation = (artistId: string, artistName: string) => {
    setImpersonatedArtistId(artistId);
    setImpersonatedName(artistName);
  };

  const stopImpersonation = () => {
    setImpersonatedArtistId(null);
    setImpersonatedName(null);
  };

  return (
    <ImpersonationContext.Provider
      value={{
        impersonatedArtistId,
        impersonatedName,
        startImpersonation,
        stopImpersonation,
        isImpersonating: !!impersonatedArtistId,
      }}
    >
      {children}
    </ImpersonationContext.Provider>
  );
}

export function useImpersonation() {
  return useContext(ImpersonationContext);
}
